import React from 'react';
import { Link } from 'react-router-dom';
const Error = props => {
    return (<div >
        <span>Oops! An error occurred</span>
        <Link to={`/`} >Back to Home</Link>

    </div>)
}
export default Error;